import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrecificacaoListComponent } from './precificacao-list/precificacao-list.component';
import { EstruturaListComponent } from './estrutura-list/estrutura-list.component';
import { PrecificacaoCriarComponent } from './precificacao-criar/precificacao-criar.component';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TabViewModule } from 'primeng/tabview';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { PainelModule } from '../shared/components/painel/painel.module';
import { DirectivesModule } from '../shared/directives/directives.module';
import { PipesModule } from '../shared/pipes/pipes.module';
import { MultiSelectModule } from 'primeng/multiselect';
import { PrecificacaoAnaliseComponent } from './precificacao-analise/precificacao-analise.component';
import { KnobModule } from 'primeng/knob';
import { PaginatorModule } from 'primeng/paginator';



@NgModule({
  declarations: [PrecificacaoListComponent, EstruturaListComponent, PrecificacaoCriarComponent, PrecificacaoAnaliseComponent],
  imports: [
    CommonModule,
    TooltipModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    ToolbarModule,
    DialogModule,
    ConfirmDialogModule,   
    PaginatorModule,     
    BrowserModule,
    ToastModule,
    SharedModule,
    CalendarModule,
    CheckboxModule,
    ScrollPanelModule,
    FieldsetModule,
    DropdownModule,
    InputNumberModule,    
    InputMaskModule,
    SelectButtonModule ,
    ProgressBarModule ,
    PipesModule ,
    PainelModule,
    ListboxModule,
    TabViewModule,
    TimelineModule,
    DirectivesModule,
    CalendarModule,
    RouterModule,
    FileUploadModule,
    HttpClientModule,
    CardModule,
    RadioButtonModule,
    InputSwitchModule,
    MultiSelectModule,
    InputNumberModule,
    KnobModule
  ]
})
export class PrecificacaoModule { }
